export const SET_CARDS = 'SET_CARDS';
export const SET_CARD_BACK_DATA = 'SET_CARD_BACK_DATA';
export const UPDATE_CARD_BACK_DATA = 'UPDATE_CARD_BACK_DATA';
export const SET_DECKS = 'SET_DECKS';

export const SET_CREATED_CATEGORY = 'SET_CREATED_CATEGORY';
export const SET_CREATED_COMPONENT = 'SET_CREATED_COMPONENT';
export const SET_TOUR_POP_STATUS = 'SET_TOUR_POP_STATUS';